import { i18n } from "../translate/i18n";

// feat_221 — mapa código Meta → texto legible para el tooltip del ícono de
// error en el chat. Espejo del mapa backend (helpers/metaErrorCodes.ts);
// mismos códigos, misma decisión de solo persistir el código crudo.
export const getMetaErrorMessage = (code) => {
  if (code === null || code === undefined) {
    return i18n.t("metaErrorCodes.default_unknown");
  }
  const key = `metaErrorCodes.${code}`;
  if (i18n.exists(key)) return i18n.t(key);
  return i18n.t("metaErrorCodes.default", { code });
};
